import { __decorate } from "tslib";
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { Loader } from 'google-maps';
let Map = class Map extends Vue {
    constructor() {
        super(...arguments);
        this.marker = {};
        this.options = { libraries: this.libraries };
        this.loader = new Loader(process.env.VUE_APP_GOOGLEMAPS_KEY, this.options);
        this.google = window.google;
    }
    async initMap() {
        if (!this.google) {
            this.google = await this.loader.load();
        }
        const map = new this.google.maps.Map(this.$refs.map, {
            center: { lat: this.location.latitude, lng: this.location.longitude },
            zoom: 15,
            mapTypeId: 'roadmap',
            disableDefaultUI: true
        });
        const pin = new this.google.maps.Marker({
            position: { lat: this.location.latitude, lng: this.location.longitude },
            map
        });
        this.$emit('getLocation', { lat: this.location.latitude, lng: this.location.longitude });
        map.addListener('click', evt => {
            pin.setPosition(evt.latLng);
            this.marker = { lat: evt.latLng.lat(), lng: evt.latLng.lng() };
            this.$emit('getLocation', this.marker);
        });
        const input = this.$refs.searchbox;
        const searchBox = new this.google.maps.places.SearchBox(input);
        map.controls[this.google.maps.ControlPosition.TOP_CENTER].push(this.$refs.searchbox);
        map.addListener('bounds_changed', () => {
            searchBox.setBounds(map.getBounds());
        });
        const geocoder = new this.google.maps.Geocoder();
        const bounds = new this.google.maps.LatLngBounds();
        pin.addListener('position_changed', () => {
            geocoder.geocode({ location: pin.getPosition() || undefined }, (result, status) => {
                if (status == 'OK') {
                    this.$emit('getLocationData', result);
                }
            });
        });
        searchBox.addListener('places_changed', () => {
            const places = searchBox.getPlaces();
            if (places.length == 0) {
                return;
            }
            places.forEach(place => {
                if (!place.geometry) {
                    return;
                }
                pin.setPosition(place.geometry.location);
                this.marker = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
                this.$emit('getLocation', this.marker);
                if (place.geometry.viewport) {
                    bounds.union(place.geometry.viewport);
                }
                else {
                    bounds.extend(place.geometry.location);
                }
            });
            map.fitBounds(bounds);
        });
    }
    async mounted() {
        await this.initMap();
    }
};
__decorate([
    Model('change', Object)
], Map.prototype, "location", void 0);
__decorate([
    Prop({ default: [] })
], Map.prototype, "libraries", void 0);
Map = __decorate([
    Component({})
], Map);
export default Map;
